<ul>
  <li *ngFor="let metagroup of metagroups">
     {{metagroup?.label}} {{metagroup?.organization}} {{metagroup?.application}}
  <button type="button" (click)="details(metagroup)">Details</button>
  </li>
</ul>
